import { useTenantSettings } from "@appretio/shared";
import { defaultWeekLabelMode } from "../components/tableControls/forecastTableControlUtils";
import type { ForecastTableControlValues } from "../components/tableControls/forecastTableControlValues";

/**
 * The tenant's default week-label display mode, from its `week_label_basis`
 * setting (`Calendar` while the settings load). The one hook every surface
 * without its own week-label toggle derives the mode from, so those surfaces
 * can't drift apart (DAS-6481).
 */
export function useDefaultWeekDisplayMode(): ForecastTableControlValues["weekLabels"] {
  const { data } = useTenantSettings();
  return defaultWeekLabelMode(data?.settings.week_label_basis.value);
}
